import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** 选品库  查询各状态的商品个数 */
export async function countRulesUsingPOST(params: { countRuleParam: model.ICountRuleParam }) {
    const result = await axios.post<model.IMessageRuleCountVo>(`/rest/op/vc/distribution/rule/countRules`, {
        ...params.countRuleParam,
    });
    return result;
}

/** 选品库  删除选品库 */
export async function deleteRuleUsingPOST(params: { deleteRuleParam: model.IDeleteRuleParam }) {
    const result = await axios.post<model.IMessage>(`/rest/op/vc/distribution/rule/delete`, {
        ...params.deleteRuleParam,
    });
    return result;
}

/** 选品库  操作小黄车，挂车或移除 */
export async function operateCarUsingPOST(params: { operateCarParam: model.IOperateCarParam }) {
    const result = await axios.post<model.IMessageOperateCarResultVo>(`/rest/op/vc/distribution/rule/operateCar`, {
        ...params.operateCarParam,
    });
    return result;
}

/** 选品库  查询选品库 */
export async function searchRulesUsingPOST(params: { searchRuleParam: model.ISearchRuleParam }) {
    const result = await axios.post<model.IMessageRuleListVo>(`/rest/op/vc/distribution/rule/searchRules`, {
        ...params.searchRuleParam,
    });
    return result;
}
